/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "./Base"

const FileDownload = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 24 25">
    <path d="M15.8535,16.1465a.5.5,0,0,1,0,.707l-3,3a.5.5,0,0,1-.707,0l-3-3a.5.5,0,0,1,.707-.707L12,18.293V10.5a.5.5,0,0,1,1,0v7.793l2.1465-2.1465A.5.5,0,0,1,15.8535,16.1465ZM23,7.9443V23.5A1.5,1.5,0,0,1,21.5,25H3.5A1.5,1.5,0,0,1,2,23.5V1.5A1.5,1.5,0,0,1,3.5,0H15.0582a1.5007,1.5007,0,0,1,1.0609.4395l6.442,6.4448A1.5,1.5,0,0,1,23,7.9443ZM15.9775,1.7119l.0186,4.79a.5006.5006,0,0,0,.5.498h4.7668ZM22,8H16.4961a1.5026,1.5026,0,0,1-1.5-1.4941L14.9746,1H3.5a.5.5,0,0,0-.5.5v22a.5.5,0,0,0,.5.5h18a.5.5,0,0,0,.5-.5Z" />
  </BaseSvgIcon>
)
export default FileDownload
